import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import CloseButton from '../../images/close-btn.svg';
import SideBarToggle from "../../images/sidebar-toggle.svg";
import { logoutUser, changeTheme } from '../../data/dataApi';
import { useUserState } from './UserStateProvider';

const DashboardSidebar = ({isActive, toggleSidebar}) => {
    const location = useLocation();
    const [activeLink, setActiveLink] = useState(location.pathname);
    const { theme, setTheme, userId, helpRequests, userCapabilities } = useUserState();

    const navigate = useNavigate();

    const { setLoggedIn } = useUserState();

    const handleLogout = async () => {
        const response = await logoutUser();
        setLoggedIn(false);
        
        response.success && navigate("/");
    };

    useEffect(() => {
        theme && changeTheme(userId, theme);
    }, [theme]);

    const menuItems = [
        {
            name: 'Home',
            link: '/dashboard/home'
        },
        {
            name: 'History',
            link: '/dashboard/history'
        },
        {
            name: 'Feedback',
            link: '/dashboard/feedback'
        },
        {
            name: 'Help Requests',
            link: '/dashboard/help-requests'
        },
        {
            name: 'Documents',
            link: '/dashboard/documents',
            show: userCapabilities.includes("read_documents"),
        },
        // {
        //     name: 'Inform the Bot',
        //     link: '/dashboard/inform-the-bot',
        //     show: userCapabilities.includes("read_inform_the_bot"),
        // },
        {
            name: 'Bot Settings',
            link: '/dashboard/bot-settings',
        },
        {
            name: 'User Accounts',
            link: '/dashboard/user-accounts',
            show: userCapabilities.includes("read_user_accounts"),
        }
    ];

    return (
        <div id="sidebar" className={`dashboard-sidebar tif-bg-color-secondary tif-bg-light-color-white ${isActive ? 'active' : ''}`}>
            <ul>
                {
                    menuItems.filter(item => item.show === undefined || item.show === true).map((item, index) => (
                        <li key={index} className={activeLink.startsWith(item.link) ? 'active' : ''}>
                            <Link to={item.link} className="sidebar-link" onClick={()=>setActiveLink(item.link)}>{item.name} { Number(helpRequests) && item.link === "/dashboard/help-requests" ? <span className="counter">{ helpRequests }</span> : <></> }</Link>
                        </li>
                    ))
                }
            </ul>
            <div className="logout-wrapper tif-py-15 tif-pl-45 tif-pr-40">
                <button className="logout" onClick={ handleLogout }>Logout</button>
                <div className={`mode-toggle ${theme === 'light' ? 'toggled-on' : 'toggled-off'}`} onClick={() => setTheme(theme === 'light' ? 'dark' : 'light')}>
                    <div className="top-half"></div>
                    <div className="bottom-half"></div>
                    <div className="toggle-switch">
                        <div className="top-half"></div>
                        <div className="bottom-half"></div>
                    </div>
                </div>
            </div>
            <button className="close-sidebar" onClick={toggleSidebar}><img alt="close button" src={CloseButton}/><span className="visually-hidden">Close Sidebar</span></button>
            <button className={`sidebar-toggle ${ isActive ? "d-none" : "" }`} onClick={toggleSidebar}><img alt="Sidebar Toggle" src={SideBarToggle}/><span className="visually-hidden">Toggle Sidebar</span></button>
        </div>
    );
};

export default DashboardSidebar;
